import { useCallback } from 'react';

export const useSkipControls = (
  videoRef: React.RefObject<HTMLVideoElement>,
  onSkipBack?: (newTime: number) => void,
  onSkipForward?: (newTime: number) => void
) => {
  // Hardcoded skip duration of 15 seconds
  const skipDuration = 15;

  const skipBack = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;
    
    const newTime = Math.max(0, video.currentTime - skipDuration);
    video.currentTime = newTime;
    onSkipBack?.(newTime);
  }, [videoRef, onSkipBack]);

  const skipForward = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;
    
    const newTime = Math.min(video.duration || 0, video.currentTime + skipDuration);
    video.currentTime = newTime;
    onSkipForward?.(newTime);
  }, [videoRef, onSkipForward]);

  // Always show skip controls
  const shouldShowSkipControls = useCallback(() => {
    return true;
  }, []);

  return {
    skipBack,
    skipForward,
    skipDuration,
    shouldShowSkipControls
  };
}; 